function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4BBCC"
    },
    d: "M470.632,37.377H41.368C18.521,37.377,0,55.898,0,78.744v354.511 c0,22.846,18.521,41.368,41.368,41.368h429.265c22.846,0,41.368-18.521,41.368-41.368V78.744 C512,55.898,493.479,37.377,470.632,37.377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A6E7FF"
    },
    d: "M473.083,233.282V102.615c0-14.537-11.784-26.321-26.321-26.321H65.238 c-14.537,0-26.321,11.784-26.321,26.321v240.014l50.002,45.511L473.083,233.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M38.909,158.803c9.339-7.358,21.125-11.747,33.937-11.747c24.26,0,44.829,15.746,52.081,37.571 c8.774-5.142,18.98-8.101,29.884-8.101c30.261,0,55.202,22.707,58.757,52.009c25.772,2.769,46.005,24.044,47.129,50.275 l-63.977,62.539l-157.801,1.281L38.909,158.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6C994E"
    },
    d: "M157.978,310.558c0,0-68.733-25.906-119.062,32.07v66.756c0,14.537,11.784,26.321,26.321,26.321 l104.657-79.174L157.978,310.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M38.917,377.353c50.329-57.976,119.062-32.07,119.062-32.07l4.391,16.942 l7.525-5.692l-11.916-45.974c0,0-68.733-25.906-119.062,32.07L38.917,377.353L38.917,377.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EB35B"
    },
    d: "M65.238,435.706c34.925-92.71,144.432-202.073,235.563-140.329l-30.288,97.379l-77.076,42.951H65.238 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M297.67,305.443l3.131-10.067 c-91.132-61.743-200.638,47.619-235.563,140.329h33.258C136.835,358.195,220.491,279.891,297.67,305.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5EB78"
    },
    d: "M473.083,409.385V233.282c-175.29-17.428-279.647,202.424-279.647,202.424h253.326 C461.299,435.706,473.083,423.922,473.083,409.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M473.083,255.484v-22.203c-175.29-17.428-279.647,202.424-279.647,202.424 h35.651C259.816,382.858,345.907,257.695,473.083,255.484z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE97A"
    },
    cx: 343.505,
    cy: 173.957,
    r: 37.155
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M317.935,185.533c0-20.517,16.633-37.15,37.15-37.15 c7.294,0,14.092,2.111,19.832,5.743c-6.584-10.405-18.184-17.318-31.407-17.318c-20.517,0-37.15,16.633-37.15,37.15 c0,13.223,6.914,24.823,17.318,31.407C320.046,199.626,317.935,192.828,317.935,185.533z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.c1a9407d7a4cd5f53d22f3223dd2aceb.svg";
export { ForwardRef as ReactComponent };